import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';


const PrivacyPolicyContainer = styled.div`
  max-width: 800px;
  margin: 40px auto;
  padding: 20px;
  font-family: 'Poppins', sans-serif;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 30px;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  color: #4862F2;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 8px;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(72, 98, 242, 0.1);
  }
`;

const Title = styled.h1`
  font-size: 28px;
  color: #0F31DB;
  margin: 0;
  flex-grow: 1;
  text-align: center;
`;

const Content = styled.div`
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

const Section = styled.section`
  margin-bottom: 30px;

  h2 {
    color: #0F31DB;
    font-size: 20px;
    margin-bottom: 15px;
  }

  p {
    color:black;
    line-height: 1.6;
    margin-bottom: 15px;
  }

  ul {
   color:black;
  }
  li {
    margin-bottom: 10px;
    color:black;
  }
`;

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    // Check if there's a previous page in history
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      // If no history, navigate to dashboard
      navigate('/dashboard');
    }
  };

  return (
    <PrivacyPolicyContainer>
      <Header>
        <BackButton onClick={handleBack}>
          ← Back
        </BackButton>
        <Title>Privacy Policy</Title>
        <div style={{ width: '100px' }}></div> {/* Spacer for alignment */}
      </Header>
      
      <Content>
        <Section>
          <h2>1. Information We Collect</h2>
          <p>Effective Date: 12/09/2024</p>
          <p>Natoe AI ("we," "us," "our") is committed to protecting the privacy of imaging centers, radiologists, and all users ("you," "your") of our services and website ("Services"). This Privacy Policy outlines how we collect, use, share, and safeguard your information.</p>
          <p>
          Introduction
          </p>
          
        </Section>
        <Section>
          <h2>2. Information We Collect</h2>
        <ul>
          <li>
          Personal Information: Name, email address, phone number, and company details provided voluntarily.
          </li>
          <li>
          Usage Data: Information about your interaction with our website and services, including IP addresses, browser types, pages visited, and timestamps.
          </li>
        </ul>
        </Section>

        <Section>
          <h2>How We Use Your Information:
</h2>
          <ul>
            <li>To provide, maintain, and improve our Services.
</li>
            <li>To communicate with you regarding service updates, webinars, and promotional materials.</li>
            <li>To ensure compliance with legal and regulatory requirements.</li>
          </ul>
        </Section>

        <Section>
          <h2>Sharing Your Information:</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
          </p>
        </Section>

        <Section>
          <h2>4. Your Rights</h2>
          <p>
          We implement industry-standard security practices to protect your personal information from unauthorized access, disclosure, or misuse.

          </p>
        </Section>
        <Section>
          <h2>Your Privacy Rights:</h2>
          <ul>
            <li>
            Access and Correction: You may request to access, update, or correct your personal data.
            </li>
            <li>Opt-Out: You can opt-out of receiving promotional communications at any time.</li>
          </ul>
        </Section>
        <Section>
          <h2>Cookies and Tracking Technologies:</h2>
          <p>
          Our website may use cookies and tracking technologies to enhance user experience and analyze usage patterns. You may manage your cookie preferences through your browser settings.

          </p>
        </Section>
        <Section>
          <h2>Third-Party Links:</h2>
          <p>
          Our website may contain links to third-party sites. We are not responsible for the privacy practices of these external websites.

          </p>
        </Section>
        <Section>
          <h2>Changes to This Privacy Policy:
</h2>
          <p>
          We may update this Privacy Policy periodically. We encourage you to review it regularly. Changes will become effective immediately upon posting.

          </p>
        </Section>
        

        <Section>
          <h2>5. Contact Us</h2>
          <p>
          For any questions or concerns regarding this Privacy Policy, please contact us:

            <br />
            <p>Email: <a href="mailto:privacy@modalitydemo.com" style={{ color: '#4862F2' }}>
              privacy@modalitydemo.com
             
            </a>
            </p>
            <p>Phone: <a href="tel:+1 (656) 241-6730" style={{ color: '#4862F2' }}>
              +1 (656) 241-6730

              </a>
            </p>
          </p>
        </Section>
      </Content>
    </PrivacyPolicyContainer>
  );
};

export default PrivacyPolicy; 